import styled from 'styled-components';
import { InputSection } from '../styles';

export const StyledInputSection = styled(InputSection)`
  flex-direction: column;
  align-items: flex-start;
  padding-top: 0.5rem;
`;
